import POIResults from './POIResults';

export default POIResults;
